import { MyClubCardsPage } from 'pages/my-cards/MyClubCardsPage';

import { PageParams } from './__generated__/routeParams';

const FootballMyClubCardsPage = () => {
  return <MyClubCardsPage<PageParams> />;
};
export default FootballMyClubCardsPage;
